import {Inject, Injectable} from '@angular/core';
import {CoreSettings} from '../models/settings/core.settings';
import {SETTINGS} from '../models/settings/settings';

// only countries with SEPA
const CODE_LENGTHS = {
  BE: 16, BG: 22, DE: 22, DK: 18, EE: 20, FO: 18, FI: 18, FR: 27,
  GB: 22, GI: 23, GL: 18, GR: 27, IE: 22, IL: 23, IT: 27, HR: 21,
  LI: 21, LT: 20, LU: 20, LV: 21, MT: 31, MC: 27, PL: 28, PT: 25,
  RO: 24, SM: 27, CH: 21, SE: 24, ES: 24, SI: 19, SK: 24, CZ: 24,
  HU: 28, CY: 28, NL: 18, NO: 15, AT: 20
};

@Injectable({providedIn: 'root'})
export class IbanValidationService {

  private _nationCountryCode: string;

  constructor(@Inject(SETTINGS) private _settings: CoreSettings) {
    this._nationCountryCode = this._getNationalCountryCode();
  }

  public validatePartialIban(iban: string, onlyNational: boolean): {error: string; format: string} {
    if (iban.length >= 2) {
      const countryCode = iban.slice(0, 2);
      const length = CODE_LENGTHS[countryCode];
      if (onlyNational && countryCode !== this._nationCountryCode) {
        return this._retValue('WRONG_NATIONAL', this._nationCountryCode, CODE_LENGTHS[this._nationCountryCode]);
      } else if (!length) {
        return this._retValue('WRONG', undefined, undefined);
      } else {
        if (iban.length < length || iban.length > length) {
          let countryCodeLength = 0;
          if (!isNaN(countryCode?.length)) {
            countryCodeLength = countryCode?.length;
          }
          return this._retValue('LENGTH', countryCode, length - countryCodeLength);
        }
      }
    } else {
      return this._retValue('WRONG', undefined, undefined);
    }
  }

  public validateIban(iban: string): boolean {
    return this._checkIbanChecksum(iban);
  }

  private _checkIbanChecksum(iban: string): boolean {
    iban = iban.replace(/^(.{4})(.*)$/, '$2$1');
    iban = iban.replace(/[A-Z]/g, (match) => (match.charCodeAt(0) - 'A'.charCodeAt(0) + 10).toString());
    let sum = 0;
    let exponent = 1;
    for (let i = iban.length - 1; i >= 0; i--) {
      sum += exponent * parseInt(iban.charAt(i), 10);
      exponent = (exponent * 10) % 97;
    }
    return (sum % 97) === 1;
  }

  private _getNationalCountryCode(): string {
    return 'DE';
  }

  private _retValue(err: string, countryCode: string, length: number): {error: string; format: string} {
    if (!countryCode && !length) {
      return {error: err, format: 'Falsches Format'};
      }
    return {error: err, format: countryCode && length ? `(Format: ${countryCode} und ${length} Ziffern)` : undefined};
  }
}
